import React from 'react'
import Image from 'react-bootstrap/Image'
import Container from 'react-bootstrap/Container'
export default class VideoCell extends React.Component { 

	getTimeStamp() {
		//TODO: implement later
	}

	getStyle() { 
		var startStyle = { 
			borderRadius: 50/2,
			border: '3px solid #b148d2',
			height: 50, 
			width: 50
		}
		return startStyle

	}

	getUrl() { 
		if (this.props.video.thumbnail === null) { 
			return "https://s3.us-east-2.amazonaws.com/gameplan-image-urls/icon.jpg"
		} else { 
			return this.props.video.thumbnail.url
		}
	}


	render() { 
		return (
			<div style={this.props.style}>
				<img 
				src={this.getUrl()}
				style={this.getStyle()}
				onClick={()=> this.props.onClick(this.props.video.url)}/>
			</div>
		)
	}
}